import { StandardButton } from "../atoms/buttons";
import { TextAtom } from "../atoms/TextAtom"
import { HorizontalLayout, VerticalLayout } from "../components/layout"

export const BuyAccounts = ({ handleAccounts, accountsTotal, activeAccounts }) => {
    return (
        <VerticalLayout className="phone-margin feature-card buy-accounts" style={{width:"unset"}}>
            <TextAtom title="Activeer accounts" className={" feature-title"} />
            <HorizontalLayout className="phone-column space-between" style={{ gap: "1rem", }}>
                <AccountNumber number={activeAccounts} />
                <AccountHandler action={(value) => handleAccounts(value)} accountsTotal={accountsTotal} />
            </HorizontalLayout>
        </VerticalLayout>
    )
}

export const BuyCards = ({ handleCards, cardsTotal, activeCards, handleBuyCards }) => {
    return (
        <VerticalLayout className="phone-margin feature-card buy-cards" style={{ width: "unset"}}>
            <TextAtom title="Koop kaarten" className={" feature-title"} />
            <HorizontalLayout className="phone-column space-between" style={{ gap: "1rem", }}>
                <CardsNumber number={activeCards} />
                <CardsHandler action={handleCards} cardsTotal={cardsTotal} />
            </HorizontalLayout>
            <StandardButton style={{width:"100%", margin:"unset", marginTop:"1rem", justifyContent:"center"}} title={"Koop extra kaarten"} onClick={handleBuyCards}/>
        </VerticalLayout>
    );
};

const CardsHandler = ({ action, cardsTotal }) => {
    return (
        <HorizontalLayout className="space-between account-handler phone-column" style={{ width: "unset" }}>
            <TextAtom title={"Nieuwe kaarten"} className="semi-bold" />
            <HorizontalLayout className="handler-buttons">
                <button
                    onClick={() => action(-1)}
                    className="standard-button grey-background-50 black-color semi-bold up-down-button"
                >
                    -
                </button>
                <TextAtom title={cardsTotal} className="semi-bold" />
                <button
                    onClick={() => action(1)}
                    className="standard-button grey-background-50 black-color semi-bold up-down-button"
                >
                    +
                </button>
            </HorizontalLayout>
        </HorizontalLayout>
    );
};

const CardsNumber = ({ number }) => {
    return (
        <VerticalLayout>
            <TextAtom title={"Aantal kaarten"} />
            <TextAtom className={"number-count"} title={number} style={{ fontSize: "1.5rem", fontWeight: "600" }} />
        </VerticalLayout>
    );
};


const AccountHandler = ({ action, accountsTotal }) => {
    return (
        <HorizontalLayout className="space-between account-handler phone-column" style={{width:"unset"  }}>
            <TextAtom title={"Nieuwe accounts"} className="semi-bold" />
            <HorizontalLayout className="handler-buttons" >
                <button onClick={() => action(-1)} className="standard-button grey-background-50 black-color semi-bold up-down-button">-</button>
                <TextAtom title={accountsTotal} className="semi-bold" />
                <button onClick={() => action(1)} className="standard-button grey-background-50 black-color semi-bold  up-down-button">+</button>
            </HorizontalLayout>
        </HorizontalLayout>)
}
const AccountNumber = ({ number }) => {
    return (
        <VerticalLayout>
            <TextAtom
                title={"Actieve accounts"}
            />
            <TextAtom
                className={"number-count"}
                title={number} 
                    style={{ fontSize: "1.5rem", fontWeight: "600" }}
                />
        </VerticalLayout>
    )
}
